import React from "react";
import { Query } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { Select } from "antd";
import PageLoader from "../PageLoader";
import { statusIcon } from "../../lib/status";
import properCase from "../../lib/properCase";

const MIGRATION_QUERY = gql`
  query migrations {
    migrations {
      status
      id
      name
    }
  }
`;

const { Option } = Select;

type MigrationSelectProps = {
  onChange?: any;
  onSelect?: any;
  value?: string;
  style?: React.CSSProperties;
  searchValue?: string;
  defaultOpen?: boolean;
  autoFocus?: boolean;
};

export default class MigrationSelect extends React.Component<MigrationSelectProps> {
  migrationSelectOptions(migrations: any[]): JSX.Element[] {
    let options = [];
    if (migrations) {
      migrations.forEach((migration) => {
        const text = `${migration.id} - ${migration.name} (${properCase(
          migration.status,
        )})`;
        options.push(
          <Option
            title={migration.name}
            value={migration.id}
            key={migration.id}
          >
            {statusIcon(migration.status, "small")} &nbsp; {text}
          </Option>,
        );
      });
    }
    return options;
  }

  render() {
    return (
      <Query query={MIGRATION_QUERY} partialRefetch={true}>
        {({ loading, data }) => {
          if (loading) {
            return <PageLoader tip="Loading..." delay={500} />;
          }

          data.migrations.slice().sort((a, b) => Number(b.id) - Number(a.id));

          return (
            <Select
              showSearch
              defaultOpen={this.props.defaultOpen}
              autoFocus={this.props.autoFocus}
              key="migrationId"
              optionFilterProp="children"
              value={this.props.value}
              searchValue={this.props.searchValue}
              onChange={this.props.onChange}
              onSelect={this.props.onSelect}
              style={this.props.style}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.migrationSelectOptions(data.migrations)}
            </Select>
          );
        }}
      </Query>
    );
  }
}
